// Package imports:
import React from 'react';
// Component imports:


const ToastControlCenter: React.FC = () => {
    return (
        <div id='ToastControlCenter'>

        </div>
    )
}

export default ToastControlCenter;